import React, { PropTypes, Component } from 'react'
import cx from 'classnames'

import InputControl from 'components/InputControl'
import './SearchOutOfCoverageArea.scss'
import { callApi } from '@src/services/api/api'
import { searchStatus } from '@src/globals'

class SearchOutOfCoverageArea extends Component {
  constructor (props) {
    super(props)

    this.saveLead = this.saveLead.bind(this)
    this.submit = this.submit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)

    this.state = {
      email: '',
      edited: false,
      success: false,
      submitting: false,
      disabled: false,
      error: '',
      touched: false,
      active: false
    }
  }

  displayError (e) {
    this.setState({
      error: e.message
    })
  }

  clearError () {
    this.setState({
      error: ''
    })
  }

  displayRequiredError () {
    const error = new Error('Required')
    this.displayError(error)
  }

  submit (e) {
    e.preventDefault()

    const { email } = this.state

    if (email) {
      this.saveLead()
    } else {
      this.displayRequiredError()
    }

    this.setState({ touched: true })
  }

  saveLead () {
    const { email } = this.state
    const { coordinates, settings } = this.props

    const payload = {
      lead: {
        email,
        coordinates,
        settings
      }
    }

    const options = {
      method: 'POST',
      body: payload
    }
    callApi('leads', options, null)
    .then(response => {
      this.setState({success: true})
    })
  }

  handleChange (e) {
    this.clearError()

    const { value: email } = e.target
    this.setState({
      email,
      edited: true
    })
  }

  handleFocus (e) {
    this.setState({
      active: true
    })
  }

  handleBlur (e) {
    this.setState({
      active: false,
      touched: true
    })
  }

  render () {
    const { neighborhood, status } = this.props
    const { email, success, disabled, submitting, ...meta } = this.state

    const buttonClassName = cx(
      'btn btn-lg btn-block',
      {
        'btn-primary': !success,
        'btn-success': success
      }
    )

    const buttonCopy = success
      ? 'Correo enviado'
      : 'Enviar'

    const buttonDisabled = disabled || submitting || success

    const input = {
      name: 'email',
      value: email,
      disabled: disabled || submitting,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      required: true
    }

    const inputControlProps = {
      label: 'Correo electrónico',
      type: 'email',
      icon: 'email',
      meta,
      input
    }

    return (
      <div className='SearchOutOfCoverageArea'>
        <p>
          No encontramos aliadas en <strong>{neighborhood}</strong>
        </p>
        <p>
          Déjanos tu correo electrónico y cuando lleguemos allá serás el primero en enterarte, además, recibirás tu primer servicio completamente gratis.
        </p>
        <form className='SearchOutOfCoverageArea-form' onSubmit={this.submit}>
          <InputControl {...inputControlProps} />
          <button
            className={buttonClassName}
            disabled={buttonDisabled}
          >
            { buttonCopy }
          </button>
        </form>
      </div>
    )
  }
}

SearchOutOfCoverageArea.displayName = 'SearchOutOfCoverageArea'
SearchOutOfCoverageArea.propTypes = {
  neighborhood: PropTypes.string.isRequired,
  coordinates: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
  }).isRequired,
  settings: PropTypes.shape({
    skills: PropTypes.array,
    preferences: PropTypes.array
  }),
  status: PropTypes.string.isRequired
}
SearchOutOfCoverageArea.defaultProps = {}

export default SearchOutOfCoverageArea



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchResults/components/SearchOutOfCoverageArea/SearchOutOfCoverageArea.js